import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/app";
import { initializeDataDog } from "app/analytics";
import { isTestUser } from "utils/helper";
import { initializeLaunchDarkly } from "app/analytics/launch-darkly";

const appPreReq = async () => {
  await initializeLaunchDarkly();
  // determine if Mock Service Worker should be running
  if (process.env.REACT_APP_MSW_ENABLED !== "true" || !isTestUser) return;
  // mswStarter
  const { worker } = await import("./test-tools/browser");
  worker.start({
    // onUnhandledRequest: "error",
    onUnhandledRequest: "bypass",
    quiet: true,
  });
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

appPreReq().then(() => {
  initializeDataDog();
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
